// pages/DashboardPage.js
import React from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';

const DashboardPage = () => {
  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div style={{ marginLeft: '240px', width: '100%' }}>
        <Navbar />
        <div style={{ padding: '20px' }}>
          <h2>Dashboard</h2>
          <p>Welcome to the admin dashboard.</p>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
